/* eslint-disable max-classes-per-file */
import Enum from '@rover/types/src/Enum';

export const FONT_FAMILY =
  "'Averta', 'Avenir', 'Helvetica Neue', 'Calibri', 'Helvetica', 'Roboto', sans-serif";
export class FontSize extends Enum<number> {
  static S = new FontSize(12);

  static M = new FontSize(14);

  static L = new FontSize(16);

  static XL = new FontSize(32);

  static XXL = new FontSize(40);

  static XXXL = new FontSize(48);

  toString(): string {
    return `${this.value}px`;
  }

  toNumber(): number {
    return this.value;
  }
}
export class FontWeight extends Enum<string> {
  static NORMAL = new FontWeight('normal'); // 400

  static HEAVY = new FontWeight('bold'); // 700

  static BOLD = new FontWeight('700');
}

const Font = {
  FontSize,
  FontWeight,
  FONT_FAMILY,
};

export default Font;
